import React from "react";
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import {Box, ChakraProvider} from "@chakra-ui/react";
import theme from "./theme";
import {categories, categoryUrl, subCategoryUrl} from "./data/catalog";
import {QuoteProvider} from "./components/QuoteContext";
import Header from "./components/Header";
import Footer, {CtaBand} from "./components/Footer";
import {BackToTop, ScrollManager} from "./components/ScrollManager";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import SubCategoryPage from "./pages/SubCategoryPage";
import GalleryPage from "./pages/GalleryPage";
import NotFound from "./pages/NotFound";

// The home page ends with its own contact section, so the CTA band is only for inner pages.
function InnerPageCta() {
    const {pathname} = useLocation();
    return pathname === "/" ? null : <CtaBand/>;
}

function App() {
    return (
        <ChakraProvider theme={theme}>
            <BrowserRouter>
                <QuoteProvider>
                    <ScrollManager/>
                    <Header/>
                    <Box as="main">
                        <Routes>
                            <Route path="/" element={<Home/>}/>
                            <Route path="/gallery" element={<GalleryPage/>}/>
                            {categories.map((category) => (
                                <Route key={category.path} path={categoryUrl(category)}
                                       element={<CategoryPage key={category.path} category={category}/>}/>
                            ))}
                            {categories.flatMap((category) => category.content.map((sub) => {
                                const url = subCategoryUrl(category, sub);
                                return (
                                    <Route key={url} path={url}
                                           element={<SubCategoryPage key={url} category={category} sub={sub}/>}/>
                                );
                            }))}
                            <Route path="*" element={<NotFound/>}/>
                        </Routes>
                    </Box>
                    <InnerPageCta/>
                    <Footer/>
                    <BackToTop/>
                </QuoteProvider>
            </BrowserRouter>
        </ChakraProvider>
    );
}

export default App;
